export default __webpack_public_path__ + "static/media/rick_and_morty.f1a2655a.png";